module.exports = __webpack_public_path__ + "media/audioTourBlip.c7664734.mp3";